import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "col-md-10 text-start home mt-4" }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-md-12 text-start" }
const _hoisted_4 = {
  key: 0,
  class: "small"
}
const _hoisted_5 = {
  key: 1,
  class: "small"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12" }
const _hoisted_8 = { class: "card p-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-md-8" }
const _hoisted_11 = { class: "col-md-2" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-md-2 bold" }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "col-md-6 text-start" }
const _hoisted_16 = { class: "col-md-2" }
const _hoisted_17 = { class: "row" }
const _hoisted_18 = { class: "col-md-2 bold" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { class: "col-md-6" }
const _hoisted_21 = { class: "col-md-2" }
const _hoisted_22 = { class: "row" }
const _hoisted_23 = { class: "col-md-2 bold" }
const _hoisted_24 = { key: 0 }
const _hoisted_25 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = { key: 2 }
const _hoisted_29 = { key: 3 }
const _hoisted_30 = { key: 4 }
const _hoisted_31 = { class: "row" }
const _hoisted_32 = { class: "col-md-12" }
const _hoisted_33 = { class: "table" }
const _hoisted_34 = { class: "text-end" }
const _hoisted_35 = {
  key: 0,
  class: "text-end"
}
const _hoisted_36 = { class: "bold" }
const _hoisted_37 = { class: "text-end" }
const _hoisted_38 = { class: "text-end" }
const _hoisted_39 = { class: "text-end" }
const _hoisted_40 = { class: "text-end" }
const _hoisted_41 = {
  key: 0,
  class: "text-end"
}
const _hoisted_42 = { class: "text-end" }
const _hoisted_43 = { key: 0 }
const _hoisted_44 = {
  colspan: "7",
  class: "pb-4"
}
const _hoisted_45 = {
  key: 0,
  class: "row mb-1"
}
const _hoisted_46 = {
  key: 0,
  class: "col-md-2"
}
const _hoisted_47 = { class: "input-group mb-3" }
const _hoisted_48 = { class: "py-2 px-2" }
const _hoisted_49 = {
  key: 1,
  class: "col-md-2"
}
const _hoisted_50 = { class: "input-group mb-3" }
const _hoisted_51 = { class: "py-2 px-2" }
const _hoisted_52 = {
  key: 2,
  class: "col-md-2"
}
const _hoisted_53 = { class: "input-group mb-3" }
const _hoisted_54 = { class: "py-2 px-2" }
const _hoisted_55 = {
  key: 3,
  class: "col-md-2"
}
const _hoisted_56 = { class: "input-group mb-3" }
const _hoisted_57 = { class: "py-2 px-2" }
const _hoisted_58 = {
  key: 4,
  class: "col-md-2"
}
const _hoisted_59 = { class: "input-group mb-3" }
const _hoisted_60 = { class: "py-2 px-2" }
const _hoisted_61 = {
  key: 5,
  class: "col-md-2"
}
const _hoisted_62 = { class: "input-group mb-3" }
const _hoisted_63 = { class: "py-2 px-2" }
const _hoisted_64 = {
  key: 6,
  class: "col-md-2"
}
const _hoisted_65 = { class: "input-group mb-3" }
const _hoisted_66 = { class: "py-2 px-2" }
const _hoisted_67 = {
  key: 7,
  class: "col-md-2"
}
const _hoisted_68 = { class: "input-group mb-3" }
const _hoisted_69 = { class: "py-2 px-2" }
const _hoisted_70 = {
  key: 8,
  class: "col-md-2"
}
const _hoisted_71 = { class: "input-group mb-3" }
const _hoisted_72 = { class: "py-2 px-2" }
const _hoisted_73 = {
  key: 9,
  class: "col-md-2"
}
const _hoisted_74 = { class: "input-group mb-3" }
const _hoisted_75 = { class: "py-2 px-2" }
const _hoisted_76 = {
  key: 1,
  class: "row"
}
const _hoisted_77 = {
  key: 0,
  class: "col-md-6"
}
const _hoisted_78 = {
  key: 1,
  class: "col-md-6"
}
const _hoisted_79 = {
  colspan: "7",
  class: "text-end"
}
const _hoisted_80 = { class: "float-end total-table" }
const _hoisted_81 = { key: 0 }
const _hoisted_82 = { class: "p-1" }
const _hoisted_83 = { class: "p-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_router_link, {
      class: "nav-link mb-2",
      to: "/orders"
    }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createElementVNode("i", { class: "bi bi-arrow-left" }, null, -1),
        _createTextVNode(" Go back ")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "bold d-inline-block" }, "Order details", -1)),
        (!_ctx.isLoading && _ctx.order)
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : (_openBlock(), _createElementBlock("span", _hoisted_5, " Loading..."))
      ])
    ]),
    _createVNode(_component_Loading, { isLoading: _ctx.isLoading }, null, 8, ["isLoading"]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("b", null, _toDisplayString(_ctx.userStore.userInfo?.companyName), 1)
                ]),
                _cache[2] || (_cache[2] = _createElementVNode("div", { class: "col-md-2" }, [
                  _createElementVNode("b", null, "Order date:")
                ], -1)),
                _createElementVNode("div", _hoisted_11, _toDisplayString(_ctx.getFormattedOrderDate(_ctx.order?.orderDate)), 1)
              ]),
              _createElementVNode("div", _hoisted_12, [
                _createElementVNode("div", _hoisted_13, [
                  (_ctx.order?.orderReference)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_14, "Order reference:"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.order?.orderReference ? _ctx.order?.orderReference : ""), 1),
                _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-md-2" }, [
                  _createElementVNode("b", null, "Order number:")
                ], -1)),
                _createElementVNode("div", _hoisted_16, _toDisplayString(_ctx.order?.orderNumber ? _ctx.order.orderNumber : "Being processed"), 1)
              ]),
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  (_ctx.order?.message)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_19, "Comment:"))
                    : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_20, _toDisplayString(_ctx.order?.orderReference ? _ctx.order?.message : ""), 1),
                _cache[4] || (_cache[4] = _createElementVNode("div", { class: "col-md-2" }, [
                  _createElementVNode("b", null, "Order status:")
                ], -1)),
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.getOrderStatusText(_ctx.order?.orderStatus)), 1)
              ]),
              _createElementVNode("div", _hoisted_22, [
                _createElementVNode("div", _hoisted_23, [
                  (_ctx.order?.deliveryAddress)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_24, "Delivery Address:"))
                    : _createCommentVNode("", true)
                ]),
                (_ctx.order?.deliveryAddress)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                      (_ctx.order.deliveryAddress.addressStreet)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_26, [
                            _cache[5] || (_cache[5] = _createElementVNode("strong", null, "Street:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.order.deliveryAddress.addressStreet), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.deliveryAddress.addressCity)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_27, [
                            _cache[6] || (_cache[6] = _createTextVNode(" | ")),
                            _cache[7] || (_cache[7] = _createElementVNode("strong", null, "City:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.order.deliveryAddress.addressCity), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.deliveryAddress.addressZipCode)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_28, [
                            _cache[8] || (_cache[8] = _createTextVNode(" | ")),
                            _cache[9] || (_cache[9] = _createElementVNode("strong", null, "Zip Code:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.order.deliveryAddress.addressZipCode), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.deliveryAddress.addressCountryRegionId)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_29, [
                            _cache[10] || (_cache[10] = _createTextVNode(" | ")),
                            _cache[11] || (_cache[11] = _createElementVNode("strong", null, "Country:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.order.deliveryAddress.addressCountryRegionId), 1)
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.order.deliveryAddress.addressDescription)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_30, [
                            _cache[12] || (_cache[12] = _createTextVNode(" | ")),
                            _cache[13] || (_cache[13] = _createElementVNode("strong", null, "Description:", -1)),
                            _createTextVNode(" " + _toDisplayString(_ctx.order.deliveryAddress.addressDescription), 1)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _cache[33] || (_cache[33] = _createElementVNode("hr", null, null, -1)),
                  _createElementVNode("table", _hoisted_33, [
                    _createElementVNode("thead", null, [
                      _createElementVNode("tr", null, [
                        _cache[14] || (_cache[14] = _createElementVNode("th", null, "Product", -1)),
                        _cache[15] || (_cache[15] = _createElementVNode("th", { class: "text-end" }, "Product number", -1)),
                        _cache[16] || (_cache[16] = _createElementVNode("th", { class: "text-end" }, "Quantity", -1)),
                        _createElementVNode("th", _hoisted_34, _toDisplayString(_ctx.order?.orderId ===
                        "00000000-0000-0000-0000-000000000000"
                          ? "Requested Shipping"
                          : "Requested Delivery"), 1),
                        _cache[17] || (_cache[17] = _createElementVNode("th", { class: "text-end" }, "Price / box", -1)),
                        (
                        !_ctx.order?.orderLines?.some(
                          (orderRow) => orderRow.itemDiscount === '0.0'
                        )
                      )
                          ? (_openBlock(), _createElementBlock("th", _hoisted_35, " Discount "))
                          : _createCommentVNode("", true),
                        _cache[18] || (_cache[18] = _createElementVNode("th", { class: "text-end" }, "Total", -1))
                      ])
                    ]),
                    _createElementVNode("tbody", null, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.order?.orderLines, (ol, index) => {
                        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_36, _toDisplayString(ol.productName), 1),
                            _createElementVNode("td", _hoisted_37, _toDisplayString(ol?.productId), 1),
                            _createElementVNode("td", _hoisted_38, _toDisplayString(_ctx.formatAmount(ol?.quantity)), 1),
                            _createElementVNode("td", _hoisted_39, [
                              _createTextVNode(_toDisplayString(_ctx.order?.orderId ===
                          "00000000-0000-0000-0000-000000000000"
                            ? _ctx.getFormattedOrderDate(ol.requestedShippingDate)
                            : _ctx.getFormattedOrderDate(ol.requestedDeliveryDate)) + " ", 1),
                              _cache[19] || (_cache[19] = _createElementVNode("br", null, null, -1))
                            ]),
                            _createElementVNode("td", _hoisted_40, _toDisplayString(_ctx.formatCurrency(
                            ol?.itemPrice,
                            _ctx.order?.currency
                              ? _ctx.order?.currency
                              : _ctx.userStore.userInfo?.currency
                          )), 1),
                            (
                          ol?.itemDiscount !== undefined &&
                          ol?.itemDiscount !== '0.0'
                        )
                              ? (_openBlock(), _createElementBlock("td", _hoisted_41, _toDisplayString(ol.itemDiscount) + " % ", 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("td", _hoisted_42, _toDisplayString(_ctx.formatCurrency(
                            ol?.totalPrice,
                            _ctx.order?.currency
                              ? _ctx.order?.currency
                              : _ctx.userStore.userInfo?.currency
                          )), 1)
                          ]),
                          (
                        ol.artworkVersion_Box ||
                        ol.artworkVersion_Label ||
                        ol.artworkVersion_Leaflet ||
                        ol.artworkVersion_Sachet ||
                        ol.artworkVersion_ShipperLabel ||
                        ol.comment ||
                        ol.requestedDeliveryDate
                      )
                            ? (_openBlock(), _createElementBlock("tr", _hoisted_43, [
                                _createElementVNode("td", _hoisted_44, [
                                  (
                            ol.artworkVersion_Box ||
                            ol.artworkVersion_Label ||
                            ol.artworkVersion_Leaflet ||
                            ol.artworkVersion_Sachet ||
                            ol.artworkVersion_ShipperLabel
                          )
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_45, [
                                        _cache[30] || (_cache[30] = _createElementVNode("div", { class: "col-md-2 pt-2" }, "Artwork version", -1)),
                                        (ol.artworkVersion_Box)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                              _createElementVNode("div", _hoisted_47, [
                                                _cache[20] || (_cache[20] = _createElementVNode("span", {
                                                  class: "input-group-text",
                                                  title: "Artwork version box"
                                                }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-box",
                                                    title: "Artwork version box"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_48, _toDisplayString(ol.artworkVersion_Box), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_Label)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_49, [
                                              _createElementVNode("div", _hoisted_50, [
                                                _cache[21] || (_cache[21] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-tag",
                                                    title: "Artwork version label"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_51, _toDisplayString(ol.artworkVersion_Label), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_Leaflet)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_52, [
                                              _createElementVNode("div", _hoisted_53, [
                                                _cache[22] || (_cache[22] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-card-list",
                                                    title: "Artwork version leaflet"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_54, _toDisplayString(ol.artworkVersion_Leaflet), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_Sachet)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                              _createElementVNode("div", _hoisted_56, [
                                                _cache[23] || (_cache[23] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-bag",
                                                    title: "Artwork version sachet"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_57, _toDisplayString(ol.artworkVersion_Sachet), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_ShipperLabel)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_58, [
                                              _createElementVNode("div", _hoisted_59, [
                                                _cache[24] || (_cache[24] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-truck",
                                                    title: "Artwork version shipper label"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_60, _toDisplayString(ol.artworkVersion_ShipperLabel), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_Blister)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                                              _createElementVNode("div", _hoisted_62, [
                                                _cache[25] || (_cache[25] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-boxes",
                                                    title: "Artwork version blister"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_63, _toDisplayString(ol.artworkVersion_Blister), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_ShipperCarton)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_64, [
                                              _createElementVNode("div", _hoisted_65, [
                                                _cache[26] || (_cache[26] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-box2",
                                                    title: "Artwork version shipper carton"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_66, _toDisplayString(ol.artworkVersion_ShipperCarton), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_PalletLabel)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_67, [
                                              _createElementVNode("div", _hoisted_68, [
                                                _cache[27] || (_cache[27] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-layout-text-sidebar",
                                                    title: "Artwork version pallet carton"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_69, _toDisplayString(ol.artworkVersion_PalletLabel), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_WrapLabel)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_70, [
                                              _createElementVNode("div", _hoisted_71, [
                                                _cache[28] || (_cache[28] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-journal-text",
                                                    title: "Artwork version Wrap Label"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_72, _toDisplayString(ol.artworkVersion_WrapLabel), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true),
                                        (ol.artworkVersion_WhiteboxLabel)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_73, [
                                              _createElementVNode("div", _hoisted_74, [
                                                _cache[29] || (_cache[29] = _createElementVNode("span", { class: "input-group-text" }, [
                                                  _createElementVNode("i", {
                                                    class: "bi bi-justify-left",
                                                    title: "Artwork version White Box Label"
                                                  })
                                                ], -1)),
                                                _createElementVNode("label", _hoisted_75, _toDisplayString(ol.artworkVersion_WhiteboxLabel), 1)
                                              ])
                                            ]))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true),
                                  (ol.comment || ol.requestedDeliveryDate)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_76, [
                                        (ol.comment)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_77, " Comment: " + _toDisplayString(ol.comment), 1))
                                          : _createCommentVNode("", true),
                                        (ol.requestedDeliveryDate)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_78, " Requested date: " + _toDisplayString(_ctx.getFormattedOrderDate(ol.requestedDeliveryDate)), 1))
                                          : _createCommentVNode("", true)
                                      ]))
                                    : _createCommentVNode("", true)
                                ])
                              ]))
                            : _createCommentVNode("", true)
                        ], 64))
                      }), 128)),
                      _createElementVNode("tr", null, [
                        _createElementVNode("td", _hoisted_79, [
                          _createElementVNode("table", _hoisted_80, [
                            _createElementVNode("tbody", null, [
                              (
                              _ctx.order?.totalDiscount != undefined &&
                              _ctx.order?.totalDiscount > 0
                            )
                                ? (_openBlock(), _createElementBlock("tr", _hoisted_81, [
                                    _cache[31] || (_cache[31] = _createElementVNode("td", { class: "p-1" }, [
                                      _createElementVNode("b", null, "Discount:  ")
                                    ], -1)),
                                    _createElementVNode("td", _hoisted_82, "-" + _toDisplayString(_ctx.order?.totalDiscount), 1)
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("tr", null, [
                                _cache[32] || (_cache[32] = _createElementVNode("td", { class: "p-1" }, [
                                  _createElementVNode("b", null, "Subtotal:  ")
                                ], -1)),
                                _createElementVNode("td", _hoisted_83, _toDisplayString(_ctx.formatCurrency(
                                  _ctx.order?.subTotal,
                                  _ctx.order?.currency
                                    ? _ctx.order?.currency
                                    : _ctx.userStore.userInfo?.currency
                                )), 1)
                              ])
                            ])
                          ])
                        ])
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}